import React, { Fragment, useEffect, useState, memo, useCallback } from 'react';
import Pagination from '../../../components/Form/Pagination';
import { EuiLoadingContent } from '@elastic/eui';
import ErrorMessage from '../../../components/UIComponent/ErrorMessage';
import { useSelector } from 'react-redux';
import APIV5 from '../../../api/axios/API5';
import ListMembershipOffer from '../../../components/offer/ListMembershipOffer';

const OfferTable = ({ currentTab, OFFER_MEMBERSHIP_LIST }) => {
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const refetchOffers = useSelector((state) => state.offersReducer.refetchOffers);

    const [membershipOfferList, setMembershipOfferList] = useState({});

    const fetchMembershipOfferList = useCallback(async () => {
        setLoading(true);
        try {
            const response = await APIV5.get(
                `restaurants/:restaurantId/membership-offers?page=${pagination.pageIndex + 1}&per_page=${
                    pagination.pageSize
                }`
            );
            setMembershipOfferList(response?.membership_offers);
            setLoading(false);
        } catch (e) {
            setError(e);
            setLoading(false);
        }
    }, [pagination.pageIndex, pagination.pageSize]);

    const handlePageChange = useCallback(
        (page) => {
            setPagination({
                ...pagination,
                pageIndex: page,
            });
        },
        [pagination]
    );

    useEffect(() => {
        fetchMembershipOfferList();
    }, [refetchOffers, pagination.pageIndex, fetchMembershipOfferList]);

    if (loading) return <EuiLoadingContent lines={4} />;
    if (error) return <ErrorMessage />;

    return (
        <Fragment>
            {/* 4th tab  */}
            <ListMembershipOffer
                membershipOfferList={membershipOfferList}
                fetchMembershipOfferList={fetchMembershipOfferList}
                pagination={pagination}
                currentTab={currentTab}
                OFFER_MEMBERSHIP_LIST={OFFER_MEMBERSHIP_LIST}
            />
            {membershipOfferList.total > membershipOfferList.per_page && (
                <Pagination
                    totalRecord={membershipOfferList.total}
                    pageSize={membershipOfferList.per_page}
                    activePage={membershipOfferList.current_page - 1}
                    handlePageChange={handlePageChange}
                />
            )}
        </Fragment>
    );
};

export default memo(OfferTable);
